import styled from 'styled-components';

export const HomeContainer = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    color: #14254C;
`
  